import React from 'react';
import { ExternalLinkIcon, SparklesIcon } from 'lucide-react';
import { SiteFooter } from '../components/ui/SiteFooter';
import { FoundingOffer } from '../components/practitioners/FoundingOffer';
import { practitionerApplicationUrl } from '../data/appTour';
import { foundingOffer } from '../data/foundingOffer';
export function PractitionersPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-550" data-mp="2za5poezujrbc">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-551" data-mp="3s0nzdyv2sqxq">
        <a href="/" aria-label="Fem Entity home" data-id="element-552" data-mp="3i2q9l6xkim30">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-553" data-mp="3i287hto85dn6" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-554" data-mp="26mtdmyrbb1wa">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-555" data-mp="zmfaxszbxulz">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-556" data-mp="13lo4awqgjqh0">
            Download the App
          </a>
          <a href="/practitioners" className="text-purple-700 font-semibold" data-id="element-557" data-mp="um13ac1n4moh">
            Practitioners
          </a>
        </div>
      </nav>

      <main className="pt-16 md:pt-24 pb-24" data-id="element-558" data-mp="fvts8hdyq5xt">
        {/* Intro */}
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-559" data-mp="kod3v8t3aqzz">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-560" data-mp="kpy1j7apaq22">
            For Practitioners
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] mb-6 tracking-tight" data-id="element-561" data-mp="bwuqf5nj2pal">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-562" data-mp="3t69a06knvtl8">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness.
          </p>
        </div>

        {/* Founding member offer */}
        <div className="max-w-3xl mx-auto px-6 mt-10" data-id="element-563" data-mp="3a6d6jdx0stka">
          <div className="rounded-3xl bg-purple-800 px-7 py-8 md:px-10 md:py-9 text-center" data-id="element-564" data-mp="357s4ra24e1tq">
            <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-200" data-id="element-565" data-mp="30a0babltu7nf">
              <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-566" data-mp="1qjlclrqutww" />
              Founding member offer
            </p>
            <p className="mt-4 font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-567" data-mp="3syxlrsjsr05m">
              {foundingOffer.headline}
            </p>
            <p className="mt-4 text-base text-purple-100/90 leading-relaxed max-w-xl mx-auto" data-id="element-568" data-mp="3j0hsbixaresy">
              {foundingOffer.subline}
            </p>
            <p className="mt-5 text-sm text-purple-200/80" data-id="element-569" data-mp="2cl7eye1alxsa">
              Offer closes {foundingOffer.deadline}.
            </p>
            <a href="#apply" className="mt-7 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-purple-900 transition-colors duration-200 ease-out hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-800" data-id="element-570" data-mp="n2se4s35l6ys">
              Apply before September 30
            </a>
          </div>
        </div>

        {/* Offer detail */}
        <div className="max-w-3xl mx-auto px-6 mt-20 md:mt-24" data-id="element-571" data-mp="1artoikvjqs6p">
          <FoundingOffer data-id="element-572" data-mp="1au7j6smbe2dq" />
        </div>

        {/* Application form */}
        <section id="apply" aria-labelledby="apply-heading" className="max-w-3xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-573" data-mp="1frz8rfzhlcer">
          <h2 id="apply-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight text-center" data-id="element-574" data-mp="3hjm4tvy8jxi3">
            Apply to the network
          </h2>
          <p className="mt-4 text-base text-charcoal/70 leading-relaxed text-center" data-id="element-575" data-mp="1gsu16r5qluii">
            Complete the form below to claim your founding membership.
          </p>

          <div className="mt-10 overflow-hidden rounded-3xl border border-purple-200 bg-white shadow-[0_18px_50px_-30px_rgba(44,44,44,0.5)]" data-id="element-576" data-mp="1pubbfswgr1za">
            <iframe src={practitionerApplicationUrl} title="Fem Entity practitioner application form" className="w-full h-[1200px] border-0" loading="lazy" data-id="element-577" data-mp="1ltreapbw3yd5" />
          </div>

          <p className="mt-6 text-center text-sm text-charcoal/60" data-id="element-578" data-mp="t27r6uc6a05v">
            Having trouble with the form?{' '}
            <a href={practitionerApplicationUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-medium text-purple-700 underline underline-offset-4 decoration-purple-300 hover:text-purple-900 hover:decoration-purple-700 transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory rounded" data-id="element-579" data-mp="124qqj4gr1und">
              Open it in a new tab
              <ExternalLinkIcon aria-hidden="true" className="w-3.5 h-3.5" data-id="element-580" data-mp="3midxhylna26v" />
            </a>
          </p>
        </section>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-581" data-mp="j044la9wifuf" />
    </div>;
}